import roomSelect from './index.vue';

var Plugin = {
  install: function install(Vue) {
    Vue.component('room-select', roomSelect);
  }
};
export { roomSelect };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/room-select/index.js
// module id = 3
// module chunks = 0